export const convertBrToNewLine = (text) => {
  if (!text || typeof text !== "string") return "";
  return text.replace(/<br\s*\/?>/gi, "\n");
};